import { useEffect, useState } from "react";
import { Select, Space, Table } from "antd";
import { PageHeader } from "../../components/PageHeader";
import { TableDownload } from "../../components/TableDownload";
import { ColumnPicker, useColumnPicker } from "../../components/ColumnPicker";
import { PrintFilters } from "../../components/PrintFilters";
import { api } from "../../helpers/api";
import { useProjectsQuery } from "../../helpers/queries";
import type { ExportColumns } from "../../helpers/csv";
import type { ProjectItemStatusRow } from "../../api-models";

// One definition behind both the table and its export.
const COLUMNS: ExportColumns<ProjectItemStatusRow> = [
  { title: "Code", dataIndex: "itemCode" },
  { title: "Item", dataIndex: "itemName" },
  { title: "Approved", dataIndex: "approvedQty" },
  { title: "Pending request", dataIndex: "pendingRequestQty" },
  { title: "Issued", dataIndex: "issuedQty" },
  { title: "Consumed", dataIndex: "consumedQty" },
  { title: "Returned", dataIndex: "returnedQty" },
  { title: "Request balance", dataIndex: "requestBalance" },
];

export default function ProjectItemStatusPage() {
  const { data: projects = [] } = useProjectsQuery();
  const [projectId, setProjectId] = useState<number>();
  const [rows, setRows] = useState<ProjectItemStatusRow[]>([]);
  const cols = useColumnPicker("report:project-item-status", COLUMNS);

  useEffect(() => {
    if (!projectId) return setRows([]);
    api.get<ProjectItemStatusRow[]>("/reports/project-item-status", { params: { projectId } }).then((res) => setRows(res.data));
  }, [projectId]);

  const project = projects.find((p) => p.id === projectId);
  // One description of the view, read by both the export header and the printed page.
  const filters = { project: project ? `${project.code} — ${project.name}` : "" };

  return (
    <div>
      <PageHeader
        title="Project Item Status"
        extra={
          <Space>
            <ColumnPicker state={cols} />
            <TableDownload
              name="Project Item Status"
              columns={cols.visible}
              dataSource={rows}
              disabled={!rows.length}
              filters={filters}
              beforeDownload={() => (projectId ? null : "Select a project first.")}
            />
          </Space>
        }
      />
      <div className="glut-filter-bar">
        <Select
          placeholder="Select a project"
          style={{ width: 280 }}
          options={projects.map((p) => ({ value: p.id, label: p.name }))}
          value={projectId}
          onChange={setProjectId}
        />
      </div>
      <PrintFilters filters={filters} />
      <Table rowKey="itemId" dataSource={rows} columns={cols.visible} />
    </div>
  );
}
